<template>
  <div class="home">
    <el-container>
      <el-header
        v-if="offsetwidth > 850"
        style="
          background-color: white;
          height: 65px;
          align-items: center;
          width: 100%;
          display: flex;
          justify-content: center;
          min-width: 1349px;
        "
        :class="{
          'battery-home-header': isBatteryHomeRoute && !isFixed,
          'fixed-header': isFixed,
          'normal-header': !isBatteryHomeRoute,
        }"
        class="main-header"
      >
        <div
          :class="[
            'nav-content',
            { 'centered-nav': isBatteryHomeRoute && !isFixed },
          ]"
        >
          <el-menu
            router
            :default-active="activeIndex"
            :background-color="getNavBackgroundColor"
            :text-color="getNavTextColor"
            active-text-color="rgb(105, 154, 255)"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            style="margin-left: 360px"
          >
            <div class="logo-container">
              <!-- :class="{ 'white-logo': isBatteryHomeRoute && !isFixed }" -->
              <img
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                @click="navigateToHome"
                alt=""
              />
            </div>
            <el-menu-item
              style="margin-left: 3%"
              index="/index"
              :class="{ 'is-active': isActive('/index') }"
              >Home</el-menu-item
            >
            <el-menu-item
              style="margin-left: 3%"
              index="/Project"
              :class="{ 'is-active': isActive('/Project') }"
              >About Us</el-menu-item
            >
            <el-menu-item
              style="margin-left: 3%"
              index="/Productslist"
              :class="{ 'is-active': isActive('/Productslist') }"
              >Products</el-menu-item
            >
            <el-menu-item
              style="margin-left: 3%"
              index="/Case"
              :class="{ 'is-active': isActive('/Case') }"
              >Gallery</el-menu-item
            >
            <el-menu-item
              style="margin-left: 3%"
              index="/ContactUs"
              :class="{ 'is-active': isActive('/ContactUs') }"
              >Contact Us</el-menu-item
            >
          </el-menu>
        </div>
      </el-header>

      <!-- <el-header v-else style="background-color: white; height: 65px">
        <el-menu
          router
          :default-active="activeIndex"
          background-color="white"
          text-color="black"
          active-text-color="rgb(34, 172, 56)"
          class="el-menu-demo"
          @select="handleSelect"
        >
          <div style="display: flex; justify-content: flex-start">
            
            <img
              style="height: 30px;margin-top:18px"
             src="../assets/Battertimg/PC/Batteryplantlogo.png"
              alt=""
              @click="navigateToHome"
            />
          </div>
          <div
      @click="showmenu = !showmenu"
      style="display: flex; align-items: center; background-color: #fff; padding: 5px 10px; border-radius: 5px; position: absolute; top: 10px; right: 10px;"
    >
      <span style="margin-right: 8px; font-size: 14px; font-weight: 600;color:#0869b5 !important">Menu</span>
      <img src="../assets/Battertimg/H5/menu.png" style="width: 40px" />
    </div>
          <el-menu-item v-show="showmenu" index="/index">Home</el-menu-item>
         
          <el-menu-item
            index="/Project"
            v-show="showmenu"
            style="text-align: left"
            >Project</el-menu-item
          >
          <el-menu-item
            v-show="showmenu"
            style="text-align: left"
            index="/Productslist"
            >Products</el-menu-item
          >
          <el-menu-item v-show="showmenu" 
             style="text-align:left" index="/Case"
            >Case</el-menu-item
          >
          <el-menu-item
            index="/ContactUs"
            v-show="showmenu"
            style="text-align: left"
            >Contact Us</el-menu-item
          >
        </el-menu>
      </el-header> -->
      <el-header
        v-else
        style="
          background-color: white;
          height: 65px;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1001;
        "
      >
        <!-- 顶部栏 -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 100%;
          "
        >
          <!-- Logo -->
          <div style="display: flex; justify-content: flex-start">
            <img
              style="height: 30px"
              src="../assets/Battertimg/PC/Batteryplantlogo.png"
              @click="navigateToHome"
              alt=""
            />
          </div>

          <!-- 菜单按钮 -->
          <div
            @click="toggleSidebar"
            style="
              display: flex;
              align-items: center;
              background-color: #fff;
              padding: 5px 10px;
              border-radius: 5px;
              cursor: pointer;
            "
          >
            <!-- <span
              style="
                margin-right: 8px;
                font-size: 14px;
                font-weight: 600;
                color: #0869b5 !important;
              "
              >Menu</span
            > -->
            <img src="../assets/Battertimg/H5/menu.png" style="width: 40px" />
          </div>
        </div>

        <!-- 侧边栏抽屉 -->
        <div
          class="mobile-sidebar"
          :class="{ 'sidebar-open': isSidebarOpen }"
          @click="closeSidebar"
        >
          <!-- 遮罩层 -->
          <div class="sidebar-overlay" @click="closeSidebar"></div>

          <!-- 侧边栏内容 -->
          <div class="sidebar-content" @click.stop>
            <!-- 侧边栏头部 -->
            <div class="sidebar-header">
              <div class="sidebar-logo">
                <img
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  @click="navigateToHome"
                  alt="Logo"
                />
              </div>
              <div class="sidebar-close" @click="closeSidebar">
                <i class="el-icon-close"></i>
              </div>
            </div>

            <!-- 导航菜单 -->
            <div class="sidebar-menu">
              <div
                class="sidebar-item"
                :class="{ active: isActive('/index') }"
                @click="handleSidebarItemClick('/index')"
              >
                Home
              </div>
              <div
                class="sidebar-item"
                :class="{ active: isActive('/Project') }"
                @click="handleSidebarItemClick('/Project')"
              >
                About Us
              </div>
              <div
                :class="{ active: isActive('/Productslist') }"
                class="sidebar-item"
                @click="handleSidebarItemClick('/Productslist')"
              >
                Products
              </div>
              <div
                :class="{ active: isActive('/Case') }"
                class="sidebar-item"
                @click="handleSidebarItemClick('/Case')"
              >
                Gallery
              </div>
              <div
                :class="{ active: isActive('/ContactUs') }"
                class="sidebar-item"
                @click="handleSidebarItemClick('/ContactUs')"
              >
                Contact Us
              </div>
            </div>
          </div>
        </div>
      </el-header>

      <div style="width: 100%" class="flex_around">
        <router-view
          style="width: 100%"
          @fun="getinfo"
          :offsetwidth="offsetwidth"
        ></router-view>
      </div>
      <!-- </el-main> -->
      <!-- <el-footer>Footer</el-footer> -->
    </el-container>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home",
  components: {
    // HelloWorld
  },
  data() {
    return {
      isSidebarOpen: false, // 新增：控制侧边栏显示
      key: "",
      showmenu: false,
      activeIndex: "/index",
      offsetheight: document.documentElement.clientHeight,
      offsetwidth: document.documentElement.clientWidth,
      isFixed: false,
      lastScrollPosition: 0,
      scrollHandler: null,
    };
  },
  computed: {
    isBatteryHomeRoute() {
      return (
        this.$route.path === "/index" ||
        this.$route.path === "/index"
      );
    },
    getNavBackgroundColor() {
      // BatteryHome页面未滚动时透明，其他情况白色
      if (this.isBatteryHomeRoute && !this.isFixed) {
        return "transparent";
      }
      return "white";
    },
    getNavTextColor() {
      // BatteryHome页面未滚动时白色文字，其他情况黑色
      if (this.isBatteryHomeRoute && !this.isFixed) {
        return "white";
      }
      return "black";
    },
    // activeIndex() {
    //   // 如果当前路径是根路径，返回 '/index'，否则返回当前路径
    //   return this.$route.path === "/" ? "/index" : this.$route.path;
    // },
  },
  watch: {
    offsetheight: function (val) {
      if (!this.timer) {
        this.offsetheight = val;
        // this.showmenu = this.offsetwidth > 700;
        // this.changeheight(val);
        this.timer = true;
        let that = this;
        let timeout = setTimeout(function () {
          // clearTimeout(timeout);/
          //频繁触发 resize 函数，会导致页面很卡
          that.timer = false;
        }, 100);
      }
    },
    // 如果 `offset ` 发生改变，这个函数就会运行
    offsetwidth: function (val) {
      if (!this.timer) {
        this.offsetwidth = val;
        // this.showmenu = this.offsetwidth > 700;
        // this.changeheight(val);
        this.timer = true;
        let that = this;
        let timeout = setTimeout(function () {
          // clearTimeout(timeout);/
          //频繁触发 resize 函数，会导致页面很卡
          that.timer = false;
        }, 100);
      }
    },
    activeIndex(newVal) {
      // 统一使用activeIndex键名
      window.sessionStorage.setItem("activeIndexh5", newVal);
    },
    $route(to, from) {
      // 新增：路由变化时更新activeIndex
      this.activeIndex = to.path;
      // window.sessionStorage.setItem("activeIndexh5", to.path);
      this.handleRouteChange();
    },
  },
  mounted() {
    // window.sessionStorage.getItem("activeIndexh5")
    //   ? (this.activeIndex = window.sessionStorage.getItem("activeIndexh5"))
    //   : "";
     // 初始化时清除可能存在的旧状态
  if (this.$route.path === '/index' || this.$route.path === '/') {
    window.sessionStorage.removeItem("activeIndexh5");
  }
  
  // 设置正确的初始值
  this.activeIndex = this.$route.path === '/' ? '/index' : this.$route.path;
    let that = this;
    window.addEventListener("resize", () => {
      window.offsetwidth = document.documentElement.clientWidth;
      that.offsetwidth = window.offsetwidth;
    });
    // 初始化路由处理
    this.handleRouteChange();

    // 添加滚动监听
    this.scrollHandler = this.throttle(this.handleScroll, 100);
    window.addEventListener("scroll", this.scrollHandler);
    // router.beforeEach((to, from, next) => {});
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  methods: {
    // 切换侧边栏
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      // 防止背景滚动
      if (this.isSidebarOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },

    // 关闭侧边栏
    closeSidebar() {
      this.isSidebarOpen = false;
      document.body.style.overflow = "";
    },
    isActive(path) {
      return this.$route.path === path || this.activeIndex === path;
    },
    // 处理侧边栏菜单项点击
    handleSidebarItemClick(route) {
      this.activeIndex = route;
      window.sessionStorage.setItem("activeIndexh5", route); // 统一键名
      this.closeSidebar();
      this.$router.push(route);
    },
    // 节流函数
    throttle(func, delay) {
      let timeoutId;
      let lastExecTime = 0;
      return function (...args) {
        const currentTime = Date.now();
        if (currentTime - lastExecTime > delay) {
          func.apply(this, args);
          lastExecTime = currentTime;
        } else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
            lastExecTime = Date.now();
          }, delay - (currentTime - lastExecTime));
        }
      };
    },

    // 处理路由变化
    handleRouteChange() {
      if (this.isBatteryHomeRoute) {
        // BatteryHome页面：初始不固定，监听滚动
        this.isFixed = window.scrollY > 100;
        // console.log(
        //   "BatteryHome route detected, initial isFixed:",
        //   this.isFixed
        // );
      } else {
        // 其他页面：始终保持固定导航栏
        this.isFixed = true;
        // console.log("Other route detected, forcing fixed header");
      }
    },

    handleScroll() {
      const currentScroll = window.scrollY;

      if (this.isBatteryHomeRoute) {
        // 只在BatteryHome页面处理滚动效果
        const shouldBeFixed = currentScroll > 100;
        if (this.isFixed !== shouldBeFixed) {
          this.isFixed = shouldBeFixed;
          // console.log(
          //   "Scroll changed isFixed to:",
          //   this.isFixed,
          //   "at scrollY:",
          //   currentScroll
          // );
        }
      }
      // 其他页面保持固定，不需要处理滚动

      this.lastScrollPosition = currentScroll;
    },

    navigateToHome() {
      this.$router.push("/index");
    },
    // ... 其他方法保持不变
    Submit1(key) {
      this.key = key;
      var PageId = document.querySelector("#pages" + key);
      if (key == 1) {
        window.scrollTo({
          top: 130,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: PageId.offsetTop,
          behavior: "smooth",
        });
      }
    },
    Submit(key) {
      this.key = key;
      var PageId = document.querySelector("#pages" + key);
      if (key == 1) {
        window.scrollTo({
          top: 130,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: PageId.offsetTop,
          behavior: "smooth",
        });
      }
    },
    getinfo(data) {
      this.activeIndex = data;
      window.sessionStorage.setItem("activeIndex", "/AboutUs");
      this.$router.push("/AboutUs");
    },
    handleSelect(key, keyPath) {
      window.sessionStorage.setItem("activeIndexh5", key);
      this.activeIndex = key;
      // this.showmenu = false;
    },
  },
};
</script>
<style lang="scss" scoped>
/* 综合优化方案：统一间距避免抖动，实现悬停效果 */

/* 1. 基础样式 - 统一所有状态的基础设置 */
.battery-home-header .nav-content .el-menu-item,
.fixed-header .nav-content .el-menu-item,
.normal-header .nav-content .el-menu-item {
  transition: color 0.3s ease;
  position: relative;
  background: transparent !important;
  color: #333 !important;
  /* 关键：统一基础布局样式 */
  margin: 0 20px !important;          /* 固定margin，避免抖动 */
  padding: 0 12px !important;         /* 固定padding，避免抖动 */
  border-radius: 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  border-bottom: none !important;
  height: auto !important;
  line-height: 1.5 !important;
}

/* 固定导航栏和普通导航栏的特殊margin设置 */
.fixed-header .nav-content .el-menu-item,
.normal-header .nav-content .el-menu-item {
  margin: 0 5px !important;           /* 这些导航栏使用不同的margin */
}

/* 2. 默认激活状态 - 使用伪元素 */
.battery-home-header .nav-content .el-menu-item.is-active,
.fixed-header .nav-content .el-menu-item.is-active,
.normal-header .nav-content .el-menu-item.is-active {
  color: white !important;
  position: relative;
  z-index: 1;
}

.battery-home-header .nav-content .el-menu-item.is-active::before,
.fixed-header .nav-content .el-menu-item.is-active::before,
.normal-header .nav-content .el-menu-item.is-active::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 25px;
  background: linear-gradient(to right, #007bff, #28a745);
  border-radius: 20px;
  transform: translateY(-50%);
  z-index: -1;
  opacity: 1;
}

/* 3. 鼠标悬停效果 - 使用伪元素 */
.battery-home-header .nav-content .el-menu-item:hover,
.fixed-header .nav-content .el-menu-item:hover,
.normal-header .nav-content .el-menu-item:hover {
  color: white !important;
  position: relative;
  z-index: 1;
}

/* 电池主页悬停动画 */
.battery-home-header .nav-content .el-menu-item:hover::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 25px;
  background: linear-gradient(to right, #007bff, #28a745);
  border-radius: 20px;
  transform: translateY(-50%);
  z-index: -1;
  opacity: 0;
  animation: expandBackground 0.3s ease forwards;
}

/* 固定导航栏悬停动画 */
.fixed-header .nav-content .el-menu-item:hover::before,
.normal-header .nav-content .el-menu-item:hover::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 25px;
  background: linear-gradient(to right, #007bff, #28a745);
  border-radius: 20px;
  transform: translateY(-50%);
  z-index: -1;
  opacity: 0;
  animation: expandBackground 0.3s ease forwards;
}

/* 4. 关键逻辑：当鼠标悬停在菜单区域时，非悬停的激活菜单变为透明 */
/* 注意：这里的选择器从 .nav-content:hover 改为 .el-menu:hover 更准确 */
.battery-home-header .el-menu:hover .el-menu-item.is-active:not(:hover)::before,
.fixed-header .el-menu:hover .el-menu-item.is-active:not(:hover)::before,
.normal-header .el-menu:hover .el-menu-item.is-active:not(:hover)::before {
  opacity: 0 !important;
  animation: none !important;
}

.battery-home-header .el-menu:hover .el-menu-item.is-active:not(:hover),
.fixed-header .el-menu:hover .el-menu-item.is-active:not(:hover),
.normal-header .el-menu:hover .el-menu-item.is-active:not(:hover) {
  color: #333 !important;
}

/* 5. 保证当前悬停的菜单（包括激活菜单）有背景 */
.battery-home-header .nav-content .el-menu-item.is-active:hover,
.fixed-header .nav-content .el-menu-item.is-active:hover,
.normal-header .nav-content .el-menu-item.is-active:hover {
  color: white !important;
}

.battery-home-header .nav-content .el-menu-item.is-active:hover::before,
.fixed-header .nav-content .el-menu-item.is-active:hover::before,
.normal-header .nav-content .el-menu-item.is-active:hover::before {
  opacity: 1 !important;
  animation: expandBackground 0.3s ease forwards;
}

/* 6. 动画定义 */
@keyframes fadeInBackground {
  from {
    opacity: 0;
    transform: translateY(-50%) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

@keyframes slideInBackground {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes expandBackground {
  from {
    opacity: 0;
    width: 0;
    left: 50%;
    right: 50%;
  }
  to {
    opacity: 1;
    width: 100%;
    left: 0;
    right: 0;
  }
}
</style>
<style lang="scss" scoped>
// 菜单悬停背景效果
/* 在原有的 .battery-home-header .nav-content 样式中添加 */
.battery-home-header .nav-content .el-menu-item:hover {
  color: white !important;
  border-radius: 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  border-bottom: none !important;
  position: relative; /* 为伪元素定位 */
  background: transparent !important; /* 移除原来的背景 */
  z-index: 1; /* 确保伪元素在文字下方 */
  transition: color 0.3s ease; /* 文字颜色过渡 */
}

.battery-home-header .nav-content .el-menu-item:hover::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 25px; /* 控制背景高度 */
  background: linear-gradient(to right, #007bff, #28a745);
  border-radius: 20px;
  transform: translateY(-50%);
  z-index: -1; /* 放在文字后面 */
  opacity: 0; /* 初始透明 */
  animation: expandBackground 0.3s ease forwards; /* 淡入动画 */
}

@keyframes fadeInBackground {
  from {
    opacity: 0;
    transform: translateY(-50%) scale(0.9); /* 缩小一点 */
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1); /* 恢复正常 */
  }
}

.fixed-header .nav-content .el-menu-item:hover {
  color: white !important;
  border-radius: 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  border-bottom: none !important;
  position: relative; /* 为伪元素定位 */
  background: transparent !important; /* 移除原来的背景 */
  z-index: 1; /* 确保伪元素在文字下方 */
  transition: color 0.3s ease;
}

.fixed-header .nav-content .el-menu-item:hover::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 25px; /* 控制背景高度 */
  background: linear-gradient(to right, #007bff, #28a745);
  border-radius: 20px;
  transform: translateY(-50%);
  z-index: -1; /* 放在文字后面 */
  opacity: 0;
  animation: expandBackground 0.3s ease forwards; /* 滑动淡入 */
}

/* 滑动淡入效果 */
@keyframes slideInBackground {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px); /* 从左边滑入 */
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

/* 对于normal-header也添加相同的悬停效果 */
.normal-header .nav-content .el-menu-item:hover {
  color: white !important;
  border-radius: 20px !important;
  display: inline-flex !important;
  align-items: center !important;
  border-bottom: none !important;
  position: relative; /* 为伪元素定位 */
  background: transparent !important; /* 移除原来的背景 */
  z-index: 1; /* 确保伪元素在文字下方 */
  transition: color 0.3s ease;
}

.normal-header .nav-content .el-menu-item:hover::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 25px; /* 控制背景高度 */
  background: linear-gradient(to right, #007bff, #28a745);
  border-radius: 20px;
  transform: translateY(-50%);
  z-index: -1; /* 放在文字后面 */
  opacity: 0;
  animation: expandBackground 0.3s ease forwards; /* 扩展动画 */
}

/* 扩展效果 - 从中间向两边扩展 */
@keyframes expandBackground {
  from {
    opacity: 0;
    width: 0;
    left: 50%;
    right: 50%;
  }
  to {
    opacity: 1;
    width: 100%;
    left: 0;
    right: 0;
  }
}
</style>
<style lang="scss" scoped>
@media (min-width: 1950px) {
  .battery-home-header .logo-container {
    left: -30% !important;
  }
}
@media (min-width: 1660px) and (max-width: 1950px) {
  .battery-home-header .logo-container {
    left: -40% !important;
  }
}
@media (min-width: 1600px) and (max-width: 1660px) {
  .battery-home-header .logo-container {
    left: -40% !important;
  }
}
/* 媒体查询适配不同屏幕尺寸 */
@media (min-width: 1600px) {
  // .battery-home-header .logo-container {
  //   left: -60% !important;
  // }
  .fixed-header .logo-container,
  .normal-header .logo-container {
    left: 15% !important;
  }
}
@media (min-width: 1201px) and (max-width: 1356px) {
  .battery-home-header .logo-container {
    left: -50% !important;
  }
}
@media (min-width: 1356px) and (max-width: 1599px) {
  .battery-home-header .logo-container {
    left: -40% !important;
  }
}
@media (min-width: 1201px) and (max-width: 1599px) {
  .fixed-header .logo-container,
  .normal-header .logo-container {
    left: 11% !important;
  }
}

@media (min-width: 1201px) and (max-width: 1370px) {
  .battery-home-header .logo-container {
    left: -40% !important;
  }
}
@media (max-width: 1201px) {
  .battery-home-header .logo-container {
    left: -30% !important;
  }
  .fixed-header .logo-container,
  .normal-header .logo-container {
    left: 11% !important;
  }
}

@media (max-width: 992px) {
  .battery-home-header .logo-container {
    left: -30% !important;
  }
  .fixed-header .logo-container,
  .normal-header .logo-container {
    left: 11% !important;
  }
}
</style>
<style lang="scss" scoped>
/* 不同屏幕下的导航栏宽度 */
@media (min-width: 1801px) and (max-width: 1930px) {
  // 1.6
  .battery-home-header .nav-content {
    width: 1600px !important;
    height: 67px !important;
  }
  .battery-home-header .nav-content .el-menu-item {
    font-size: 15px !important;
  }
}
@media (min-width: 1600px) and (max-width: 1800px) {
  // 1.4
  .battery-home-header .nav-content {
    width: 1466px !important;
    height: 58px !important;
  }
  .battery-home-header .nav-content .el-menu-item {
    font-size: 15px !important;
  }
}

@media (min-width: 1440px) and (max-width: 1600px) {
  // 1.26
  .battery-home-header .nav-content {
    width: 1260px !important;
    height: 53px !important;
  }
}

@media (min-width: 1301px) and (max-width: 1439px) {
  // 1.14
  .battery-home-header .nav-content {
    width: 1141px !important;
    height: 47px !important;
  }
}
@media (min-width: 1200px) and (max-width: 1300px) {
  .battery-home-header .nav-content {
    width: 1000px !important;
    height: 42px !important;
  }
}
</style>
<style lang="scss" scoped>
/* 基础头部样式 */
.main-header {
  height: 65px;
  align-items: center;
  width: 100%;
  display: flex;
  justify-content: center;
  min-width: 1349px;
  z-index: 1001; /* 提高基础z-index */
  transition: all 0.3s ease;
}

/* BatteryHome页面 - 初始透明悬浮状态 */
.battery-home-header {
  position: absolute !important;
  top: 6% !important;
  left: 0;
  background: transparent !important;
  box-shadow: none !important;
  z-index: 1001 !important; /* 设置较高的z-index */
  .logo-container {
    position: absolute;
    //  left: 10px !important;
    top: 50%;
    transform: translateY(-50%);
    height: auto;
    z-index: 1002;
  }
  .logo-container img {
    height: 28px !important;
    position: relative;
    // cursor: pointer;
  }
  .nav-content {
    width: 1000px; /* 设置固定宽度 */
    height: 42px; /* 设置固定高度 */
    // max-width: 80% !important;
    // max-width: 1000px !important;
    margin: 0 auto;
    border-radius: 60px;
    // background: rgb(255 255 255 / 66%);
    background: rgb(255, 255, 255);
    backdrop-filter: blur(5px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2) !important; /* 投影透明度20% */
    position: relative; /* 添加相对定位，作为logo的参考 */

    .el-menu {
      // height: 42px;
      display: flex;
      align-items: center;
      border-bottom: none !important;
      justify-content: center;
    }

    .el-menu-item {
      height: auto !important;
      line-height: 1.5 !important;
      display: flex;
      align-items: center;
      color: #333 !important;
      font-weight: 600;
      font-size: 14px;
      margin: 0 20px !important; /* 增加文字间距 */
      background-color: rgba(255, 255, 255, 0) !important;
      padding: 0 12px !important; /* 增加内边距使间距更明显 */

      // &:hover {
      //   color: rgb(12, 128, 218) !important;
      // border-bottom-color: rgb(12, 128, 218) !important;
      //   background-color: rgba(255, 255, 255, 0) !important;
      // }
    }

    .el-menu-item.is-active {
      // color: rgb(12, 128, 218) !important;
      // border-bottom-color: rgb(12, 128, 218) !important;
      // background-color: rgba(255, 255, 255,0) !important;
      /* 删除这行：background: linear-gradient(to right, #007bff, #28a745) !important; */
  color: white !important;
  border-radius: 20px;
  padding: 2px 16px !important;
  height: auto !important;
  display: inline-flex;
  align-items: center;
  margin: auto 20px !important;
  position: relative; /* 确保伪元素能正确显示 */
    }
  }
}

/* 白色logo样式（用于BatteryHome初始状态） */
.white-logo {
  filter: brightness(0) invert(1); /* 使logo变为白色 */
}

.el-header {
  z-index: 10;
  ul {
    margin-left: 0 !important;
    display: contents;
  }
}
.flex_around {
  display: flex;
  justify-content: space-around;
}

.h5elmenu {
  color: rgb(34, 172, 56) !important;
  background-color: white !important;
}
@media screen and (min-width: 919px) {
  .el-menu {
    border-right: solid 1px #e6e6e6;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #fff;
  }
}
.el-button {
  color: #fff;
  background-color: #545c64;
  border: 1px solid #fff;
  font-weight: 700;
}
.content {
  height: calc(100vh - 60px);
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-menu-item {
  background-color: white !important;
  font-size: 15px;
  font-weight: 700;
  border-bottom: none !important;
}
.el-menu--horizontal {
  background-color: white !important;
  font-size: 15px;
  font-weight: 700;
}
::v-deep.el-menu--horizontal > .el-submenu .el-submenu__title {
  // background-color: white !important;
}

::v-deep.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  // color: rgb(34, 172, 56) !important;
  // background-color: white !important;
  // border-bottom-color: rgb(34, 172, 56) !important;
}
::v-deep.el-menu--horizontal > .el-submenu .el-submenu__title.is-active {
  // color: rgb(34, 172, 56) !important;
  // background-color: white !important;
  // border-bottom-color: rgb(34, 172, 56) !important;
}
.el-menu-item.is-active {
  // color: rgb(34, 172, 56) !important;

  border-bottom-color: rgb(8, 136, 237) !important;
  color: rgb(8, 136, 237) !important;
  // background-color: rgb(105, 154, 255) !important;
}

.el-menu-item:hover {
  //  color:white !important;
  // background-color: rgb(105, 154, 255) !important;
  // color: rgb(34, 172, 56) !important;
  // background-color: white !important;
  // border-bottom-color: rgb(34, 172, 56) !important;
}

.el-menu--horizontal .el-menu {
  background: none;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  // background-color: rgb(34, 172, 56);
  // float: none;
  // height: 36px;
  // line-height: 36px;
  // padding: 0 22px;
  // color: rgb(34, 172, 56) !important;
  // z-index: 100;
  // font-weight: 500;
}

// 二级菜单 选中的样式
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: rgb(34, 172, 56) !important;
  // background-color: white !important;
  border-bottom-color: rgb(34, 172, 56) !important;
}
// 二级菜单 选中的样式
.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  color: rgb(34, 172, 56) !important;
  // background-color: white !important;
  border-bottom-color: rgb(34, 172, 56) !important;
}
// .el-submenu__title {
//   font-weight: 700;
//   font-size: 14px;
//   color: #303133;
//   padding: 0 20px;
//   cursor: pointer;
//   transition: border-color 0.3s, background-color 0.3s, color 0.3s;
//   box-sizing: border-box;
// }
/* 深选择器：如果相对设置了scoped的子组件里的元素进行控制可以使用'>>>'或者'deep'设置选中或悬浮的颜色*/
::v-deep .el-submenu .el-submenu__title {
  font-weight: 700;
  font-size: 14px;
  color: #303133;
  //  background-color: white !important;
}
.wg_80 {
  width: 80%;
}
.wg_65 {
  width: 65%;
}
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 确保header在其他内容之上 */
}
.some-other-element {
  position: relative; /* 或absolute/fixed，根据需要 */
  z-index: 999; /* 确保这个元素在header之下 */
}
/* 基础导航样式 */
.nav-container {
  transition: all 0.5s ease;
  z-index: 1000;
  position: static; /* 覆盖默认定位 */
}

/* BatteryHome特有的悬浮样式 */

.home-nav {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  background: transparent !important;
  box-shadow: none !important;

  .el-menu-item {
    color: white !important;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  }
}
/* 吸顶样式 */
.fixed-nav {
  position: fixed !important;
  top: 0 !important;
  animation: fadeInDown 0.5s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1) !important;

  .el-menu-item {
    color: #333 !important;
    text-shadow: none;
  }
}

/* 吸顶动画 */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 内容区域需要添加顶部内边距 */
.content-wrapper {
  padding-top: 65px;
}

.el-main {
  padding-top: 65px;
}
/* 响应式调整 */
@media (max-width: 850px) {
  .home-nav {
    position: relative !important;
    background: white !important;

    .el-menu-item {
      color: #333 !important;
      text-shadow: none;
    }
  }
}
.header {
  position: absolute;
  top: 0;
  width: 100%;
  background: transparent;
  transition: all 0.5s ease;
  z-index: 1000;
}
/* 确保其他状态的导航栏保持白色背景 */
.fixed-header,
.normal-header {
  .el-menu-item {
    background-color: white !important;
  }

  .el-menu-item:hover {
    background-color: white !important;
  }

  .el-menu-item.is-active {
    background-color: white !important;
  }
}

/* 吸顶状态和正常状态 logo垂直居中 */
.fixed-header .logo-container,
.normal-header .logo-container {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: auto;
}

/* 调整logo高度为40px */
.fixed-header .logo-container img,
.normal-header .logo-container img {
  height: 35px !important;
}
/* 吸顶导航栏样式 */
.fixed-header {
  position: fixed !important;
  top: 0 !important;
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.3s ease;
  z-index: 1001 !important; /* 设置较高的z-index */

  .nav-content {
    width: 100%;

    .el-menu {
      background: transparent !important;
    }

    .el-menu-item {
      color: #333 !important;
      text-shadow: none;
      margin: 0 20px !important;

      // &:hover {
      //     background: linear-gradient(to right, #007bff, #28a745) !important;
      // color: white !important;
      // border-radius: 20px !important;
      // padding: 2px 12px !important;
      // height: 25px !important;
      // display: inline-flex !important;
      // align-items: center !important;
      // margin: auto 5px !important;
      // border-bottom: none !important;
      // }
    }

    .el-menu-item.is-active {
      color: white !important;
  border-radius: 20px;
  padding: 2px 16px !important;
  height: auto !important;
  display: inline-flex;
  align-items: center;
  margin: auto 20px !important;
  position: relative; /* 确保伪元素能正确显示 */
      // background: linear-gradient(to right, #007bff, #28a745) !important;
      // color: white !important;
      // border-radius: 20px !important;
      // padding: 2px 12px !important;
      // height: 25px !important;
      // display: inline-flex !important;
      // align-items: center !important;
      // margin: auto 5px !important;
      // border-bottom: none !important;
      // color: rgb(12, 128, 218) !important;
      // border-bottom-color: rgb(12, 128, 218) !important;
      // background: transparent !important;
    }

    .logo-container img {
      filter: none;
    }
  }
}

.centered-nav {
  width: 80%;
  max-width: 1200px;
}
/* 动画 */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 原有的其他样式保持不变 */
.el-header {
  z-index: 10;

  ul {
    margin-left: 0 !important;
    display: contents;
  }
}

.flex_around {
  display: flex;
  justify-content: space-around;
}

/* 调试信息 */
.debug-info {
  position: absolute;
  right: 20px;
  top: 20px;
  color: red;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.8);
  padding: 2px 5px;
  border-radius: 3px;
}

/* 响应式设计 */
@media screen and (max-width: 920px) {
  .el-header {
    z-index: 1001 !important; /* 确保移动端导航栏也有较高的z-index */
  }
  .el-menu {
    z-index: 99;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #283144;
    justify-content: space-around;
  }

  .el-menu-item {
    font-size: 14px;
    text-align: left;
    color: #303133;
    padding: 0 12px;
    cursor: pointer;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    box-sizing: border-box;
  }

  /* 移动端不需要特殊效果 */
  .battery-home-header {
    position: relative !important;
    top: 0 !important;
    background: white !important;

    .nav-content {
      width: 100%;
      background: transparent !important;
      backdrop-filter: none !important;
    }

    .el-menu-item {
      color: #333 !important;
      text-shadow: none;
      background-color: white !important;
    }

    .logo-container img {
      filter: none !important;
    }
  }
}

/* 确保BatteryHome页面的内容从顶部开始，不会被导航栏遮挡 */
:deep(.battery-home-content) {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
/* 其他页面的正常固定导航栏 */
.normal-header {
  position: fixed;
  top: 0;
  background: white !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001 !important; /* 添加这行，设置更高的z-index */
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nav-content {
  width: 100%;
  display: flex;
  justify-content: center;
  transition: all 0.3s ease;
}
.el-carousel__button {
  background-color: white !important;
}
</style>
<style lang="scss" scoped>
/* 移动端导航栏固定定位 */
@media (max-width: 850px) {
  .el-header {
    padding: 0 10px !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1001 !important;
    background: white !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  /* 确保移动端内容不会被导航栏遮挡 */
  .flex_around {
    margin-top: 65px !important;
  }

  /* 侧边栏需要更高的z-index来覆盖固定导航栏 */
  .mobile-sidebar {
    z-index: 2000 !important;
  }
}

/* 移动端侧边栏样式 */
.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  visibility: hidden;
  transition: visibility 0.3s ease;
}

/* 侧边栏打开状态 */
.mobile-sidebar.sidebar-open {
  visibility: visible;
}

/* 遮罩层 */
.sidebar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sidebar-open .sidebar-overlay {
  opacity: 1;
}

/* 侧边栏内容 - 宽度减少 */
.sidebar-content {
  position: absolute;
  top: 0;
  right: -240px; /* 调整宽度 */
  width: 220px; /* 减少宽度 */
  height: 100%;
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.sidebar-open .sidebar-content {
  right: 0;
}

/* 侧边栏头部 */
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px;
  border-bottom: 1px solid #e8e8e8;
  background: #f8f9fa;
}

.sidebar-logo img {
  height: 25px;
}

.sidebar-close {
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 5px;
  transition: color 0.3s ease;
}

.sidebar-close:hover {
  color: #0869b5;
}

/* 侧边栏菜单 */
.sidebar-menu {
  flex: 1;
  // padding: 20px 0;
}

/* 侧边栏菜单项 - 文字居中 */
.sidebar-item {
  border-bottom: 1px solid #dcdfe6;
  padding: 15px 20px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center; /* 文字居中 */
  position: relative;
  margin: 8px 15px; /* 增加间距 */
  // border-radius: 8px;
}

/* 悬停状态 - 蓝色字体和下划线 */
.sidebar-item:hover {
  color: #0c80da; /* 蓝色字体 */
  background: #f0f8ff; /* 浅蓝色背景 */
}

.sidebar-item:hover::after {
  content: "";
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  // background: #0c80da;
}

/* 激活状态 - 蓝色字体和下划线 */
.sidebar-item.active {
  background: linear-gradient(to right, #007bff, #28a745) !important;
  color: white !important;
  border-radius: 20px !important;
  font-weight: 600;
  margin: 8px 15px;
  border: none !important;
  // color: #0c80da;
  // // background: #f0f8ff;
  // font-weight: 600;
}

.sidebar-item.active::after {
  // content: "";
  // position: absolute;
  // bottom: 8px;
  // left: 50%;
  // transform: translateX(-50%);
  // width: 40px;
  // height: 2px;
  // background: #0c80da;
  display: none !important;
}

/* 移除之前的渐变背景和左边框 */
.sidebar-item.active {
  // background: linear-gradient(to right, #007bff, #28a745) !important;
  // border-left: 4px solid transparent !important;
}

/* 侧边栏底部 */
.sidebar-footer {
  padding: 20px 15px;
  border-top: 1px solid #e8e8e8;
  background: #f8f9fa;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  text-align: left; /* 联系信息保持左对齐 */
}

.contact-item i {
  margin-right: 8px;
  font-size: 14px;
  color: #0869b5;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .sidebar-content {
    width: 200px; /* 小屏幕进一步减少宽度 */
    right: -200px;
  }

  .sidebar-item {
    padding: 12px 15px;
    font-size: 15px;
    margin: 6px 10px;
  }
}

/* 小屏幕优化 */
@media (max-width: 360px) {
  .sidebar-content {
    width: 180px;
    right: -180px;
  }

  .sidebar-header {
    padding: 15px 12px;
  }

  .sidebar-item {
    padding: 10px 12px;
    font-size: 14px;
    margin: 5px 8px;
  }
}

/* 防止背景滚动 */
body.sidebar-open {
  overflow: hidden;
}
</style>